<template>
    <div data-v-9d87a3d9="" data-v-46377044="" class="more-info">
        <div data-v-9d87a3d9="" class="more-time">
            <div data-v-9d87a3d9="" class="time-tips">
                <div data-v-e30046ca="" data-v-9d87a3d9="" class="c-match-process text-center row a-row">
                    <div data-v-e30046ca="" class="jingcai" style="display: none;"></div>
                    <div data-v-e30046ca="" class="time-content">
                        <div data-v-e30046ca="" class="process-name">
                            <div data-v-e30046ca="" class="process_name" v-if="firstEvent.sptid==3 || firstEvent.sptid==12 || firstEvent.sptid==21">{{ firstEvent.rbinfo.st=='NL'? sportTableLang.table['SPORT_TABLE.LBL_SET_S1'] : sportTableLang.table['SPORT_TABLE.LBL_SET_'+firstEvent.rbinfo.st] }}</div>
                            <div data-v-e30046ca="" class="process_name" v-else-if="firstEvent.sptid==23">{{ firstEvent.rbinfo.st=='NL'? sportTableLang.table['SPORT_TABLE.LIVE'] : sportTableLang.table['SPORT_TABLE.LBL_INN_'+firstEvent.rbinfo.st] }}</div>
                            <div data-v-e30046ca="" class="process_name" v-else-if="firstEvent.sptid==14">{{ firstEvent.rbinfo.st=='NL'? sportTableLang.table['SPORT_TABLE.LIVE'] : sportTableLang.table['SPORT_TABLE.LBL_PERIOD_'+firstEvent.rbinfo.st] }}</div>
                            <div data-v-45641ae6="" class="process_name" v-else-if="firstEvent.sptid==20">{{ firstEvent.rbinfo.st=='NL'? sportTableLang.table['SPORT_TABLE.LIVE'] : sportTableLang.table['SPORT_TABLE.LBL_GAME_'+firstEvent.rbinfo.st] }}</div>
                            <div data-v-45641ae6="" class="process_name" v-else-if="firstEvent.sptid==15">{{ firstEvent.rbinfo.st=='NL'? sportTableLang.table['SPORT_TABLE.LIVE'] : sportTableLang.table['SPORT_TABLE.LBL_FRAME_'+firstEvent.rbinfo.st] }}</div>
                            <div data-v-45641ae6="" class="process_name" v-else-if="firstEvent.sptid==13">{{ firstEvent.rbinfo.st=='NL'? sportTableLang.table['SPORT_TABLE.LIVE'] : sportTableLang.table['SPORT_TABLE.LBL_Q_'+firstEvent.rbinfo.st] }}</div>
                            <div data-v-e30046ca="" class="process_name" v-else-if="firstEvent.sptid==19">
                                <template v-if="firstEvent.rbinfo.st=='NL'">
                                    {{ sportTableLang.table['SPORT_TABLE.LIVE'] }}
                                </template>
                                <template v-else-if="firstEvent.rbinfo.st=='H1'">
                                    {{ sportAllBetLang['ALL_BET.LBL_1HT'] }}
                                </template>
                                <template v-else-if="firstEvent.rbinfo.st=='H2'">
                                    {{ sportAllBetLang['ALL_BET.LBL_2HT'] }}
                                </template>
                            </div>
                            <div data-v-e30046ca="" class="process_name" v-else> {{ sportTableLang.table['SPORT_TABLE.LIVE'] }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div data-v-9d87a3d9="" class="scorll-handel">
                <span data-v-9d87a3d9="" class="scroll-arrow" id="prev" v-if="sportColLength[firstEvent.sptid]>5">
                    <i data-v-e826ac10="" data-v-9d87a3d9="" class="q-icon icon-arrow arrow-left c-icon set-color" aria-hidden="true" style="color:rgb(109, 114, 120); font-size: 10px; display: none;"> </i>
                </span>
                <div data-v-9d87a3d9="" class="time-node mini">
                    <template v-if="firstEvent.sptid==3 || firstEvent.sptid==12 || firstEvent.sptid==21">  <!--  || firstEvent.sptid==20 || firstEvent.sptid==15 -->
                        <span data-v-9d87a3d9="" class="current_color" v-for="n in sportColLength[firstEvent.sptid]" v-if="n==1&&firstEvent.rbinfo.st=='NL'">{{ n }}</span>
                        <span data-v-9d87a3d9="" class="" :class="firstEvent.rbinfo.st=='S'+n?'current_color':''" v-else>{{ n }}</span>
                    </template>
                    <!-- <template v-else-if="firstEvent.sptid==14 || firstEvent.sptid==23"> 
                        <span data-v-9d87a3d9="" class="current_color" v-for="n in sportColLength[firstEvent.sptid]" v-if="n==1&&firstEvent.rbinfo.st=='NL'">{{ n }}</span>
                        <span data-v-9d87a3d9="" class="" :class="firstEvent.rbinfo.st=='S'+n?'current_color':''" v-else-if="n!=sportColLength[firstEvent.sptid]">{{ n }}</span>
                        <span data-v-9d87a3d9="" class="" v-else :class="firstEvent.rbinfo.st=='OT'?'current_color':''">{{ firstEvent.sptid==23 ? sportTableLang.table['SPORT_TABLE.LBL_OS_OT1'] : sportTableLang.table['SPORT_TABLE.LBL_OS_OT'] }}</span>
                    </template> -->
                    <!-- <template v-else-if="firstEvent.sptid==13">
                        <span data-v-9d87a3d9="" class="current_color" v-for="n in sportColLength[firstEvent.sptid]" v-if="n==1&&firstEvent.rbinfo.st=='NL'">Q{{ n }}</span>
                        <span data-v-9d87a3d9="" class="" :class="firstEvent.rbinfo.st=='S'+n?'current_color':''" v-else-if="n<3">Q{{ n }}</span>
                        <span data-v-9d87a3d9="" class="" :class="firstEvent.rbinfo.st=='S'+(n-1)?'current_color':''" v-else-if="n>3">Q{{ n-1 }}</span>
                        <span data-v-9d87a3d9="" class="" v-else>{{ sportTableLang.table['SPORT_TABLE.LBL_SCORE_HT'] }}</span>
                    </template> -->
                    <!-- <template v-else-if="firstEvent.sptid==19">
                        <div class="result-icon-wrap"><div :title="sportAllBetLang['ALL_BET.LBL_1HT']" class="result-icon rs_jin_shang"></div></div>
                        <div class="result-icon-wrap"><div :title="sportAllBetLang['ALL_BET.LBL_FT']" class="result-icon rs_jin_quan"></div></div>
                    </template> -->
                    <template v-else-if="firstEvent.sptid==13 || firstEvent.sptid==23 || firstEvent.sptid==14 || firstEvent.sptid==19 || firstEvent.sptid==7 || firstEvent.sptid==15 || firstEvent.sptid==20">
                        <template v-if="firstEvent.rbinfo.score['S1'] && (firstEvent.sptid==14 || firstEvent.sptid==23)"> 
                            <span data-v-9d87a3d9="" class="current_color" v-for="n in sportColLength[firstEvent.sptid]" v-if="n==1&&firstEvent.rbinfo.st=='NL'">{{ n }}</span>
                            <span data-v-9d87a3d9="" class="" :class="firstEvent.rbinfo.st=='S'+n?'current_color':''" v-else-if="n!=sportColLength[firstEvent.sptid]">{{ n }}</span>
                            <span data-v-9d87a3d9="" class="" v-else :class="firstEvent.rbinfo.st=='OT'?'current_color':''">{{ firstEvent.sptid==23 ? sportTableLang.table['SPORT_TABLE.LBL_OS_OT1'] : sportTableLang.table['SPORT_TABLE.LBL_OS_OT'] }}</span>
                        </template> 
                        <template v-else>
                            <div class="result-icon-wrap"><div :title="sportAllBetLang['ALL_BET.LBL_FT']" class="result-icon rs_jin_quan"></div></div>
                        </template>
                    </template>
                </div>
                <span data-v-9d87a3d9="" class="scroll-arrow" id="next" v-if="sportColLength[firstEvent.sptid]>5">
                    <i data-v-e826ac10="" data-v-9d87a3d9="" class="q-icon icon-arrow arrow-right c-icon set-color" aria-hidden="true" style="color:rgb(109, 114, 120); font-size: 10px;"> </i>
                </span>
                <template v-if="firstEvent.sptid==3">
                    <div data-v-9d87a3d9="" class="add-stage">{{ sportTableLang.table['SPORT_TABLE.LBL_TN_SET'] }}</div>
                    <div data-v-9d87a3d9="" class="score">{{ sportTableLang.table['SPORT_TABLE.LBL_TN_P'] }}</div>
                </template>
                <template v-else-if="firstEvent.rbinfo.score['S1'] && firstEvent.sptid==23">
                    <div data-v-9d87a3d9="" class="add-stage score">R</div>
                    <!--div data-v-9d87a3d9="" class="other-score">H</div-->
                </template>
                <template v-else-if="firstEvent.sptid==12 || firstEvent.sptid==21">
                    <div data-v-9d87a3d9="" class="add-stage">{{ sportTableLang.table['SPORT_TABLE.LBL_GAME'] }}</div>
                    <div data-v-9d87a3d9="" class="score">{{ sportTableLang.table['SPORT_TABLE.TOTAL_SCORE'] }}</div>
                </template>
                <template v-else-if="firstEvent.rbinfo.score['S1'] && firstEvent.sptid==14">
                    <div data-v-9d87a3d9="" class="add-stage score">{{ sportTableLang.table['SPORT_TABLE.TOTAL_SCORE'] }}</div>
                </template>
                <!-- <template v-else-if="firstEvent.sptid==20">
                    <div data-v-9d87a3d9="" class="add-stage score">{{ sportTableLang.table['SPORT_TABLE.LBL_TN_SET'] }}</div>
                </template> -->
                <!-- <template v-else-if="firstEvent.sptid==15">
                    <div data-v-9d87a3d9="" class="add-stage score">{{ sportTableLang.table['SPORT_TABLE.LBL_GAME'] }}</div>
                </template>
                <template v-else-if="firstEvent.sptid==7 || firstEvent.sptid==13">
                    <div data-v-9d87a3d9="" class="common-score score last">{{ sportTableLang.table['SPORT_TABLE.TOTAL_SCORE'] }}</div>
                </template> -->
            </div>
        </div>
        <div data-v-9d87a3d9="" class="more-both">
            <div data-v-9d87a3d9="" class="both-item relative-position">
                <!-- <div data-v-9d87a3d9="" class="wrap-round"></div> -->
                <!-- <img data-v-9d87a3d9="" src="https://image.fwjaz.com/group1/M00/43/52/CgURt2e0xnyAN8aOAAADGtBmQcI836.png" class="both-logo" data-team="L" data-csid="undefined" style="opacity: 1;"> -->
                <div data-v-9d87a3d9="" class="both-name ellipsis">
                    <span data-v-9d87a3d9="" class="ellipsis" v-html="firstEvent.tacapt"></span>
                </div>
                <div data-v-9d87a3d9="" class="scorll-handel">
                    <div data-v-9d87a3d9="" class="time-node mini" :style="sportColLength[firstEvent.sptid]>5 ? 'margin: 0px 13px 0px 14px;':'margin: 0px;'">
                        <template v-if="firstEvent.sptid==3 || firstEvent.sptid==12 || firstEvent.sptid==21"> <!--  || firstEvent.sptid==20 || firstEvent.sptid==15 -->
                            <template v-if="firstEvent.rbinfo.st!='NL'">
                                <span data-v-9d87a3d9="" class="" v-for="n in sportColLength[firstEvent.sptid]" :class="firstEvent.rbinfo.st=='S'+n?'current_color':''" v-if="firstEvent.rbinfo.score['S'+n]">{{ firstEvent.rbinfo.score['S'+n]['scoa'] }}</span>
                                <span data-v-9d87a3d9="" class="" v-else></span>
                            </template>
                            <template v-else>
                                <span data-v-9d87a3d9="" class="current_color" v-if="firstEvent.rbinfo.st=='NL'">{{ firstEvent.rbinfo.score['NL']['scoa'] }}</span>
                                <span data-v-9d87a3d9="" class="" v-for="n in (sportColLength[firstEvent.sptid]-1)"></span>
                            </template>
                        </template>
                        <!-- <template v-else-if="firstEvent.sptid==14 || firstEvent.sptid==23">
                            <template v-if="firstEvent.rbinfo.st!='NL'">
                                <span data-v-9d87a3d9="" class="" v-for="n in sportColLength[firstEvent.sptid]" :class="firstEvent.rbinfo.st=='S'+n?'current_color':''" v-if="firstEvent.rbinfo.score['S'+n]&&n!=sportColLength[firstEvent.sptid]">{{ firstEvent.rbinfo.score['S'+n]['scoa'] }}</span>
                                <span data-v-9d87a3d9="" class="" v-else-if="firstEvent.rbinfo.st=='OT'" :class="firstEvent.rbinfo.st=='OT'?'current_color':''">{{ firstEvent.rbinfo.score['OT']['scoa'] }}</span>
                                <span data-v-9d87a3d9="" class="" v-else></span>
                            </template>
                            <template v-else>
                                <span data-v-9d87a3d9="" class="current_color" v-if="firstEvent.rbinfo.st=='NL'">{{ firstEvent.rbinfo.score['NL']['scoa'] }}</span>
                                <span data-v-9d87a3d9="" class="" v-for="n in (sportColLength[firstEvent.sptid]-1)"></span>
                            </template>
                        </template> -->
                        <!-- <template v-else-if="firstEvent.sptid==13">
                            <template v-if="firstEvent.rbinfo.st!='NL'">
                                <span data-v-9d87a3d9="" class="" v-for="n in sportColLength[firstEvent.sptid]" :class="firstEvent.rbinfo.st=='S'+n?'current_color':''" v-if="n<3&&firstEvent.rbinfo.score['S'+n]">{{ firstEvent.rbinfo.score['S'+n]['scoa'] }}</span>
                                <span data-v-9d87a3d9="" class="" v-else-if="n>3&&firstEvent.rbinfo.score['S'+(n-1)]" :class="firstEvent.rbinfo.st=='S'+(n-1)?'current_color':''">{{ firstEvent.rbinfo.score['S'+(n-1)]['scoa'] }}</span>
                                <span data-v-9d87a3d9="" class="" v-else-if="n==3&&firstEvent.rbinfo.score['S'+n]">{{ getScoreSet(firstEvent, 'A') }}</span>
                                <span data-v-9d87a3d9="" class="" v-else></span>
                            </template>
                            <template v-else>
                                <span data-v-9d87a3d9="" class="current_color" v-if="firstEvent.rbinfo.st=='NL'">{{ firstEvent.rbinfo.score['NL']['scoa'] }}</span>
                                <span data-v-9d87a3d9="" class="" v-for="n in (sportColLength[firstEvent.sptid]-1)"></span>
                            </template>
                        </template> -->
                        <!-- <template v-else-if="firstEvent.sptid==19">
                            <template v-if="firstEvent.rbinfo.score">
                                <template v-if="firstEvent.rbinfo.st!='NL'">
                                    <span v-if="firstEvent.rbinfo.score['H1']&&firstEvent.rbinfo.score['H1']['scoa']!=''">{{ firstEvent.rbinfo.score['H1']['scoa'] }}</span>
                                    <span v-else>-</span>
                                    <span v-if="firstEvent.rbinfo.score['H2']&&firstEvent.rbinfo.score['H2']['scoa']!=''">{{ firstEvent.rbinfo.score['H2']['scoa'] }}</span>
                                    <span v-else>-</span>
                                </template>
                                <template v-else>
                                    <span class="current_color" v-if="firstEvent.rbinfo.st=='NL'">{{ firstEvent.rbinfo.score['NL']['scoa'] }}</span>
                                    <span>-</span>
                                </template>
                            </template>
                        </template> -->
                        <template v-else-if="firstEvent.sptid==23 || firstEvent.sptid==14 || firstEvent.sptid==15 || firstEvent.sptid==19 || firstEvent.sptid==20">
                            <template v-if="firstEvent.rbinfo.score['S1'] && (firstEvent.sptid==14 || firstEvent.sptid==23)"> 
                                <template v-if="firstEvent.rbinfo.st!='NL'">
                                    <span data-v-9d87a3d9="" class="" v-for="n in sportColLength[firstEvent.sptid]" :class="firstEvent.rbinfo.st=='S'+n?'current_color':''" v-if="firstEvent.rbinfo.score['S'+n]&&n!=sportColLength[firstEvent.sptid]">{{ firstEvent.rbinfo.score['S'+n]['scoa'] }}</span>
                                    <span data-v-9d87a3d9="" class="" v-else-if="firstEvent.rbinfo.st=='OT'" :class="firstEvent.rbinfo.st=='OT'?'current_color':''">{{ firstEvent.rbinfo.score['OT']['scoa'] }}</span>
                                    <span data-v-9d87a3d9="" class="" v-else></span>
                                </template>
                                <template v-else>
                                    <span data-v-9d87a3d9="" class="current_color" v-if="firstEvent.rbinfo.st=='NL'">{{ firstEvent.rbinfo.score['NL']['scoa'] }}</span>
                                    <span data-v-9d87a3d9="" class="" v-for="n in (sportColLength[firstEvent.sptid]-1)"></span>
                                </template>
                            </template>
                            <template v-else>
                                <div data-v-9d87a3d9="" class="score add-stage">{{ getScoreSet(firstEvent, 'A') }}</div>
                            </template>
                        </template>
                        <template v-else-if="firstEvent.sptid==13">
                            <div data-v-9d87a3d9="" class="score add-stage">{{ getScoreSet(firstEvent, 'A', true) }}</div>
                        </template>
                        <template v-else-if="firstEvent.sptid==7">
                            <div data-v-9d87a3d9="" class="score add-stage" :style="(getScoreSet(firstEvent, 'A', true)).includes('/') ? 'width: 50px !important; text-align: right;':''">{{ getScoreSet(firstEvent, 'A', true) }}</div>
                        </template>
                    </div>
                    <div data-v-9d87a3d9="" :class="sportColLength[firstEvent.sptid]>5 && (firstEvent.sptid==23||firstEvent.sptid==15) ? 'score add-stage' : firstEvent.sptid==14 ? 'score add-stage':'add-stage'" v-if="firstEvent.sptid!=13 && firstEvent.sptid!=19 && firstEvent.sptid!=23 && firstEvent.sptid!=14 && firstEvent.sptid!=15 && firstEvent.sptid!=7 && firstEvent.sptid!=20">{{ getScoreSet(firstEvent, 'A') }}</div>
                    <div data-v-9d87a3d9="" :class="sportColLength[firstEvent.sptid]>5 && (firstEvent.sptid==23||firstEvent.sptid==15) ? 'score add-stage' : firstEvent.sptid==14 ? 'score add-stage':'add-stage'" v-else-if="firstEvent.rbinfo.score['S1'] && (firstEvent.sptid==23 || firstEvent.sptid==14)">{{ getScoreSet(firstEvent, 'A') }}</div>
                    <template v-if="firstEvent.sptid==3">
                        <div data-v-9d87a3d9="" class="score" v-if="firstEvent.rbinfo.score['PT']">{{ firstEvent.rbinfo.score['PT']['scoa'] }}</div>
                        <div data-v-9d87a3d9="" class="score" v-else>-</div>
                    </template>
                    <!-- <template v-else-if="firstEvent.rbinfo.score['S1'] && firstEvent.sptid==23">
                        <div data-v-9d87a3d9="" class="score">{{ getScoreSet(firstEvent, 'A', true) }}</div>
                    </template> -->
                    <template v-else-if="firstEvent.sptid==12 || firstEvent.sptid==21">
                        <div data-v-9d87a3d9="" class="score">{{ getScoreSet(firstEvent, 'A', true) }}</div>
                    </template>
                    <!-- <template v-else-if="firstEvent.sptid==13">
                        <div data-v-9d87a3d9="" class="common-score score last">{{ getScoreSet(firstEvent, 'A', true) }}</div>
                    </template> -->
                </div>
            </div>
            <div data-v-9d87a3d9="" class="both-item relative-position">
                <!-- <div data-v-9d87a3d9="" class="wrap-round">
                <span data-v-9d87a3d9="" class="round"></span>
                </div> -->
                <!-- <img data-v-9d87a3d9="" src="https://image.fwjaz.com/group1/M00/4A/39/CgURtWgAtNmAB8etAAAHauC1vgM648.png" class="both-logo" data-team="X" data-csid="undefined" style="opacity: 1;"> -->
                <div data-v-9d87a3d9="" class="both-name ellipsis">
                    <span data-v-9d87a3d9="" class="ellipsis" v-html="firstEvent.tbcapt"></span>
                </div>
                <div data-v-9d87a3d9="" class="scorll-handel">
                    <div data-v-9d87a3d9="" class="time-node mini" :style="sportColLength[firstEvent.sptid]>5 ? 'margin: 0px 13px 0px 14px;':'margin: 0px;'">
                        <template v-if="firstEvent.sptid==3 || firstEvent.sptid==12 || firstEvent.sptid==21"> <!--  || firstEvent.sptid==20 || firstEvent.sptid==15 -->
                            <template v-if="firstEvent.rbinfo.st!='NL'">
                                <span data-v-9d87a3d9="" class="" v-for="n in sportColLength[firstEvent.sptid]" :class="firstEvent.rbinfo.st=='S'+n?'current_color':''" v-if="firstEvent.rbinfo.score['S'+n]">{{ firstEvent.rbinfo.score['S'+n]['scob'] }}</span>
                                <span data-v-9d87a3d9="" class="" v-else></span>
                            </template>
                            <template v-else>
                                <span data-v-9d87a3d9="" class="current_color" v-if="firstEvent.rbinfo.st=='NL'">{{ firstEvent.rbinfo.score['NL']['scob'] }}</span>
                                <span data-v-9d87a3d9="" class="" v-for="n in (sportColLength[firstEvent.sptid]-1)"></span>
                            </template>
                        </template>
                        <!-- <template v-else-if="firstEvent.sptid==14 || firstEvent.sptid==23"> 
                            <template v-if="firstEvent.rbinfo.st!='NL'">
                                <span data-v-9d87a3d9="" class="" v-for="n in sportColLength[firstEvent.sptid]" :class="firstEvent.rbinfo.st=='S'+n?'current_color':''" v-if="firstEvent.rbinfo.score['S'+n]&&n!=sportColLength[firstEvent.sptid]">{{ firstEvent.rbinfo.score['S'+n]['scob'] }}</span>
                                <span data-v-9d87a3d9="" class="" v-else-if="firstEvent.rbinfo.st=='OT'" :class="firstEvent.rbinfo.st=='OT'?'current_color':''">{{ firstEvent.rbinfo.score['OT']['scob'] }}</span>
                                <span data-v-9d87a3d9="" class="" v-else></span>
                            </template>
                            <template v-else>
                                <span data-v-9d87a3d9="" class="current_color" v-if="firstEvent.rbinfo.st=='NL'">{{ firstEvent.rbinfo.score['NL']['scob'] }}</span>
                                <span data-v-9d87a3d9="" class="" v-for="n in (sportColLength[firstEvent.sptid]-1)"></span>
                            </template>
                        </template> -->
                        <!-- <template v-else-if="firstEvent.sptid==13">
                            <template v-if="firstEvent.rbinfo.st!='NL'">
                                <span data-v-9d87a3d9="" class="" v-for="n in sportColLength[firstEvent.sptid]" :class="firstEvent.rbinfo.st=='S'+n?'current_color':''" v-if="n<3&&firstEvent.rbinfo.score['S'+n]">{{ firstEvent.rbinfo.score['S'+n]['scob'] }}</span>
                                <span data-v-9d87a3d9="" class="" v-else-if="n>3&&firstEvent.rbinfo.score['S'+(n-1)]" :class="firstEvent.rbinfo.st=='S'+(n-1)?'current_color':''">{{ firstEvent.rbinfo.score['S'+(n-1)]['scob'] }}</span>
                                <span data-v-9d87a3d9="" class="" v-else-if="n==3&&firstEvent.rbinfo.score['S'+n]">{{ getScoreSet(firstEvent, 'B') }}</span>
                                <span data-v-9d87a3d9="" class="" v-else></span>
                            </template>
                            <template v-else>
                                <span data-v-9d87a3d9="" class="current_color" v-if="firstEvent.rbinfo.st=='NL'">{{ firstEvent.rbinfo.score['NL']['scob'] }}</span>
                                <span data-v-9d87a3d9="" class="" v-for="n in (sportColLength[firstEvent.sptid]-1)"></span>
                            </template>
                        </template> -->
                        <!-- <template v-else-if="firstEvent.sptid==19">
                            <template v-if="firstEvent.rbinfo.score">
                                <template v-if="firstEvent.rbinfo.st!='NL'">
                                    <span v-if="firstEvent.rbinfo.score['H1']&&firstEvent.rbinfo.score['H1']['scob']!=''">{{ firstEvent.rbinfo.score['H1']['scob'] }}</span>
                                    <span v-else>-</span>
                                    <span v-if="firstEvent.rbinfo.score['H2']&&firstEvent.rbinfo.score['H2']['scob']!=''">{{ firstEvent.rbinfo.score['H2']['scob'] }}</span>
                                    <span v-else>-</span>
                                </template>
                                <template v-else>
                                    <span class="current_color" v-if="firstEvent.rbinfo.st=='NL'">{{ firstEvent.rbinfo.score['NL']['scob'] }}</span>
                                    <span>-</span>
                                </template>
                            </template>
                        </template> -->
                        <template v-else-if="firstEvent.sptid==23 || firstEvent.sptid==14 || firstEvent.sptid==15 || firstEvent.sptid==19 || firstEvent.sptid==20">
                            <template v-if="firstEvent.rbinfo.score['S1'] && (firstEvent.sptid==14 || firstEvent.sptid==23)"> 
                                <template v-if="firstEvent.rbinfo.st!='NL'">
                                    <span data-v-9d87a3d9="" class="" v-for="n in sportColLength[firstEvent.sptid]" :class="firstEvent.rbinfo.st=='S'+n?'current_color':''" v-if="firstEvent.rbinfo.score['S'+n]&&n!=sportColLength[firstEvent.sptid]">{{ firstEvent.rbinfo.score['S'+n]['scob'] }}</span>
                                    <span data-v-9d87a3d9="" class="" v-else-if="firstEvent.rbinfo.st=='OT'" :class="firstEvent.rbinfo.st=='OT'?'current_color':''">{{ firstEvent.rbinfo.score['OT']['scob'] }}</span>
                                    <span data-v-9d87a3d9="" class="" v-else></span>
                                </template>
                                <template v-else>
                                    <span data-v-9d87a3d9="" class="current_color" v-if="firstEvent.rbinfo.st=='NL'">{{ firstEvent.rbinfo.score['NL']['scob'] }}</span>
                                    <span data-v-9d87a3d9="" class="" v-for="n in (sportColLength[firstEvent.sptid]-1)"></span>
                                </template>
                            </template>
                            <template v-else>
                                <div data-v-9d87a3d9="" class="score add-stage">{{ getScoreSet(firstEvent, 'B') }}</div>
                            </template>
                        </template>
                        <template v-else-if="firstEvent.sptid==13">
                            <div data-v-9d87a3d9="" class="score add-stage">{{ getScoreSet(firstEvent, 'B', true) }}</div>
                        </template>
                        <template v-else-if="firstEvent.sptid==7">
                            <div data-v-9d87a3d9="" class="score add-stage" :style="(getScoreSet(firstEvent, 'B', true)).includes('/') ? 'width: 50px !important; text-align: right;':''">{{ getScoreSet(firstEvent, 'B', true) }}</div>
                        </template>
                    </div>
                    <div data-v-9d87a3d9="" :class="sportColLength[firstEvent.sptid]>5 && (firstEvent.sptid==23||firstEvent.sptid==15) ? 'score add-stage' : firstEvent.sptid==14 ? 'score add-stage':'add-stage'" v-if="firstEvent.sptid!=13 && firstEvent.sptid!=19 && firstEvent.sptid!=23 && firstEvent.sptid!=14 && firstEvent.sptid!=15 && firstEvent.sptid!=7 && firstEvent.sptid!=20">
                        {{ getScoreSet(firstEvent, 'B') }}
                    </div>
                    <div data-v-9d87a3d9="" :class="sportColLength[firstEvent.sptid]>5 && (firstEvent.sptid==23||firstEvent.sptid==15) ? 'score add-stage' : firstEvent.sptid==14 ? 'score add-stage':'add-stage'" v-else-if="firstEvent.rbinfo.score['S1'] && (firstEvent.sptid==23 || firstEvent.sptid==14)">
                        {{ getScoreSet(firstEvent, 'B') }}
                    </div>
                    <template v-if="firstEvent.sptid==3">
                        <div data-v-9d87a3d9="" class="score" v-if="firstEvent.rbinfo.score['PT']">{{ firstEvent.rbinfo.score['PT']['scob'] }}</div>
                        <div data-v-9d87a3d9="" class="score" v-else>-</div>
                    </template>

                    <!-- <template v-else-if="firstEvent.rbinfo.score['S1'] && firstEvent.sptid==23">
                        <div data-v-9d87a3d9="" class="score">{{ getScoreSet(firstEvent, 'B', true) }}</div>
                    </template> -->
                    <template v-else-if="firstEvent.sptid==12 || firstEvent.sptid==21">
                        <div data-v-9d87a3d9="" class="score">{{ getScoreSet(firstEvent, 'B', true) }}</div>
                    </template>
                    <!-- <template v-else-if="firstEvent.sptid==13">
                        <div data-v-9d87a3d9="" class="common-score score last">{{ getScoreSet(firstEvent, 'B', true) }}</div>
                    </template> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
  mapGetters
} from 'vuex'

import EventBus from '../../events/event-bus'
import DateFilter from '@/vue/filters/date'
import moment from 'moment'
import 'moment/locale/zh-cn'

export default {
    props: {
        sportColLength: {
            type: Object
        },
    },
    computed: {
        ...mapGetters([
        'sportTableLang',
        'sportAllBetLang',
        'matchAllBet',
        'sortedMatchEventList',
        'market',
        'tvIconFlag',
        'allBetReloading',
        'selectedShow',
        'selectedMarket',
        'selectedBettype',
        'selectedAllBetNew',
        'selected_AllBetTab',
        'selectedSport',
        'selectedMatchAllBet',
        'foldopenAllBet',
        'foldopenFirstEvent',
        'show_Unfold',
        'showRightBanner',
        'firstEvent',
        'livetv',
        'open_RBMarket',
        'timeZone',
        'betForm',
        'simpleSport',
        'liveSchedule',
        'liveMatch',
        'isOpenTv',
        ]),
    },
    methods:{
        getScoreSet(event, team, total=false){
            let teamA = 0
            let teamB = 0
            let hasRec= 0;
            if(event.rbinfo!=undefined && event.rbinfo.score!=undefined){
                _.forEach(event.rbinfo.score, function (data, key) {
                    hasRec=1;
                    if(event.sptid==3){
                        if(key == 'SH'){
                            teamA = data.scoa
                            teamB = data.scob
                        }/*
                        if(key != 'PT' && key != event.rbinfo.st){
                            if(data.scoa > data.scob){
                                teamA += 1
                            }else if(data.scoa < data.scob){
                                teamB += 1
                            }
                        }*/
                    }else if(event.sptid==23){
                        // if(key != 'OT' && key != event.rbinfo.st){
                            // teamA += parseInt(data.scoa)
                            // teamB += parseInt(data.scob)
                            if(key == 'FT'){
                                teamA = parseInt(data.scoa)
                                teamB = parseInt(data.scob)
                            }
                        // }
                    }else if(event.sptid==14){
                        // if(key != 'OT'){
                            // teamA += parseInt(data.scoa)
                            // teamB += parseInt(data.scob)
                            if(key == 'FT'){
                                teamA = parseInt(data.scoa)
                                teamB = parseInt(data.scob)
                            }
                        // }
                    }else if(event.sptid==12||event.sptid==21){
                        if(total){
                            // teamA += parseInt(data.scoa)
                            // teamB += parseInt(data.scob)
                            if(key == 'PT'){
                                teamA = parseInt(data.scoa)
                                teamB = parseInt(data.scob)
                            }
                        }else{
                            if(key == 'SH'){
                                teamA = parseInt(data.scoa)
                                teamB = parseInt(data.scob)
                            }/*
                            if(key != event.rbinfo.st){
                                if(data.scoa > data.scob){
                                    teamA += 1
                                }else if(data.scoa < data.scob){
                                    teamB += 1
                                }
                            }*/
                        }
                    }else if(event.sptid==20 || event.sptid==15){
                        /*if(key != event.rbinfo.st){
                            if(data.scoa > data.scob){
                                teamA += 1
                            }else if(data.scoa < data.scob){
                                teamB += 1
                            }
                        }*/
                        if(key == 'FT'){
                            teamA = parseInt(data.scoa)
                            teamB = parseInt(data.scob)
                        }
                    }else if(event.sptid==13){
                        if(total){
                            // teamA += parseInt(data.scoa)
                            // teamB += parseInt(data.scob)
                            if(key == 'FT'){
                                teamA = parseInt(data.scoa)
                                teamB = parseInt(data.scob)
                            }
                        // }else{
                        //     if(key == 'S1' || key == 'S2'){
                        //         teamA += parseInt(data.scoa)
                        //         teamB += parseInt(data.scob)
                        //     }
                        }
                    }else if(event.sptid==7 || event.sptid == 19){
                        // teamA = data.scoa
                        // teamB = data.scob
                        if(key == 'FT'){
                            teamA = data.scoa
                            teamB = data.scob
                        }
                    }
                })
            }
            if(hasRec==0){
                return '-'
            }
            return team == 'A' ? teamA : teamB
        },
    }
}
</script>


// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/osAllBetHeader.vue